import jwtDecode from 'jwt-decode'
import { get } from 'lodash'
import { ROLES } from '../constants/enums'

export const getToken = user => {
  return user && user.access_token
}

export const getUsername = user => {
  const token = getToken(user)

  return jwtDecode(token)
}

export const getFullName = user => {
  if (!user) {
    return ''
  }
  return `${user.firstName} ${user.lastName}`
}

export const getSignupRole = user => {
  if (!user) {
    return ''
  }

  if (user.grant && user.grant[0].u) {
    return user.grant[0].u
  }

  if (user.access_token) {
    return jwtDecode(user.access_token).grant[0].u
  }

  return ''
}

export const getRole = user => {
  return user && user.grant && user.grant[0].u
}

export const getActiveRole = (user = {}) => {
  if (!user || user.userTypes) {
    return
  }
  // modify and check if activeOrganization ID is present in userTypes
}

export const getUserType = user => {
  const userTypes = get(user, 'userTypes')
  const userType =
    userTypes &&
    userTypes.find(item => item.organizations && item.organizations.length > 0)

  return userType && userType.userType
}

export const hasUserRole = (user, role) =>
  get(user, 'userTypes', [])
    .filter(item => get(item, 'organizations.length', 0) > 0)
    .some(item => item.userType === role)

export const hasMultipleRoles = user => {
  let moreOrgs = false
  const moreRoles =
    get(user, 'userTypes', []).filter(item => {
      const orgCount = get(item, 'organizations.length', 0)

      if (orgCount > 1) {
        moreOrgs = true
      }

      return orgCount > 0
    }).length > 1

  return moreRoles || moreOrgs
}

export const hasOnlyAssessorRoles = user => {
  const otherRoles = get(user, 'userTypes', []).filter(item => {
      return get(item, 'userType') !== ROLES.ASSESSOR.u
    })

  return otherRoles && otherRoles.length === 0
}

export const getOrganization = user => {
  if (get(user, 'userTypes')) {
    return user.userTypes
      .filter(item => get(item, 'userType').toLowerCase() === getRole(user))
      .map(item => item.organizations[0])
      .join()
  }

  return user
}

export const getOrganizations = user => {
  return (
    get(user, 'userTypes[0].organizations') &&
    user.userTypes[0].organizations.map(item => ({
      value: item,
      label: item
    }))
  )
}

export const selectFirstOrganization = user => {
  if (!get(user, 'userTypes[0].organizations')) {
    return {}
  }

  return get(user, 'userTypes', []).filter(userType =>
    userType.organizations.some(organization => organization.id)
  )[0].organizations[0]
}

export const selectFirstAssessorOrganization = user => {
  if (!get(user, 'userTypes[0].organizations')) {
    return {}
  }

  return get(user, 'userTypes', []).filter(userType =>
    userType.userType === ROLES.ASSESSOR.u && userType.organizations.some(organization => organization.id)
  )[0].organizations[0]
}

export const multipleOrganizations = user => {
  return (
    get(user, 'userTypes[0].organizations') &&
    user.userTypes[0].organizations.length > 1
  )
}

export const getLeaderId = user => {
  return get(user, 'awardLeaderIds[0]')
}

export const personId = user => {
  return get(user, 'personId')
}

export const getPhotoUrl = user => {
  return get(user, 'photoUrl')
}
